import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { searchDocuments, getDocument } from '../actions/document';

const getIdentifier = ({ link }) => {
  if (!link) return null;
  const match = link.match(/\/([^/]*)$/);
  return match ? decodeURIComponent(match[1]) : null;
};

export default handleActions({
  [getDocument]: {
    next(state, { payload, meta: { identifier } }) {
      return {
        ...state,
        [decodeURIComponent(identifier)]: { id: payload.id }
      };
    },
    throw(state, { payload: { response }, meta: { identifier } }) {
      return state[identifier] ? state : {
        ...state,
        [decodeURIComponent(identifier)]: {
          error: response && response.status
        }
      };
    }
  },
  [searchDocuments]: {
    next(state, { payload }) {
      return payload.items.reduce((newState, doc) => {
        const identifier = getIdentifier(doc);
        return identifier
          ? { ...newState, [identifier]: { id: doc.id } }
          : newState;
      }, state);
    }
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/document-index.js